import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/service/api.service';
import { API_ENDPOINTS } from '../../core/api/api-endpoint';

@Injectable({ providedIn: 'root' })
export class AccessKeyService {
  private api = inject(ApiService);
  
    list(payload: any, id: string | number): Observable<any> {
    return this.api.get(API_ENDPOINTS.ACCESS_KEY.LIST(id), payload);
  }

  generate(payload: any, id: string | number): Observable<any> {
    return this.api.put(API_ENDPOINTS.ACCESS_KEY.GENERATE(id), payload);
  }
}